import axios from "axios";

export default {
    data() {
        return {
                //Timer
       TimerObject: {}
        }
    },

    methods: {
      visitChange(){
        this.visitRList = [];
        if(this.selectedVisitT.length > 0){
         for(var k=0;k<this.selectedVisitT.length;k++){
           for(var m=0;m<this.visitReason_1.length;m++){
           if(this.selectedVisitT[k].visitTypeId == this.visitReason_1[m].visitTypeId){
            this.visitRList.push(this.visitReason_1[m]);
           }
          }
         }
        }
        else {
           this.selectedVisitT = [];
           this.visitRList = []; 
          }
  
          if(this.selectedVisitT.length > 0){
            this.reasonD = true;
          } else { this.reasonD = false; }
        this.fetchInitData();
       },
       visitReasonChange(){
        this.fetchInitData();
       },
       stageChange(){
        this.fetchInitData();
       },
        SearchDataTable() {
           const name = this.searchFilter.toLowerCase();
           if(name !== "") { 
           this.nameArr = name.split(" "); 
            if(this.nameArr.length == 1) {this.firstName = this.nameArr[0];}
            else{ 
                this.firstName = this.nameArr[0];
                this.lastName = this.nameArr[1];}
           } else{
                this.firstName = "";
                this.lastName = "";
           }
           this.fetchInitData();
          },
        datePickerPR() {
            const self = this;
            $('input[name="daterangePR"]').daterangepicker(
                {
                    opens: "left",
                },
                function (start, end) {
                    self.startDatePR = new Date(start);
                    self.endDatePR = new Date(end);
                    self.initDatePR =
                        self.dateToMDY(self.startDatePR) +
                        " - " +
                        self.dateToMDY(self.endDatePR);
                }
            );
        },
  //code for Data-Tables_
  pageChange(obj) {
    if (obj == "Next") {
      if (this.pageNumber < this.totalPages) {
        this.pageNumber += 1;
      }
    } else if (obj == "Previous" && this.pageNumber != 1) {
      this.pageNumber -= 1;
    } else {
      this.pageNumber = obj;
    }
    //show pagination
    if((this.showPagesMax/2) < (this.pageNumber))
    {
      this.showPagesMin = this.pageNumber-4;
      this.showPagesMax = this.pageNumber+4;
    }
    else if((this.showPagesMin/2)<(this.pageNumber))
    {
      this.showPagesMin = this.pageNumber-4;
      this.showPagesMax = this.pageNumber+4 ;
      if(this.showPagesMax<5)
      {
        this.showPagesMax = 5;
      }
    }
    else{
      this.showPagesMin = 1;
      this.showPagesMax = 5 ;
    }
     //show pagination
    this.fetchInitData();
  },
  orderBy(column) {
    if (this.sortColumn == column) {
      switch (this.sortColumnOption) {
        case 0:
          this.sortColumnOption = 1;
          break;
        case 1:
          this.sortColumnOption = 2;
          break;
        case 2:
          this.sortColumn = 0;
          this.sortColumnOption = 0;
          break;
      }
    } else {
      this.sortColumn = column;
      this.sortColumnOption = 1;
    }
    this.pageNumber = 1;
    this.fetchInitData();
  },
  //search
  applyDateClick() {
    this.pageNumber = 1;
    this.fetchInitData();
   },
  //Timer
  StartLogoutTime() {
    this.TimerObject = setTimeout(() => {
      this.AutoLogout();
    }, this.LogoutTime);
  },
  ResetLogoutTime() {
    clearTimeout(this.TimerObject);
    this.TimerObject = setTimeout(() => {
      this.AutoLogout();
    }, this.LogoutTime);
  },

        loadInit() {
            const dd = new Date();
            dd.setDate(dd.getDate() - 30);

            this.startDatePR = new Date();
            this.endDatePR = new Date();
            this.initDatePR =
                this.dateToMDY(this.startDatePR) +
                " - " +
                this.dateToMDY(this.endDatePR);

            this.fetchInitData();
            this.StartLogoutTime();
        },
        getVistReasnStage(){
          this.intDummyComm();
          this.dummyComm.filter = "";
            
          const filter = {
              veinsId: "",
              externalId: "",
              firstName: "",
              lastName: "",
              phone: "",
              startDate: "",
              endDate: ""
            };
      
          const myData = {
            dc: this.dummyComm,
            filter: filter,
            sortColumn: this.sortColumn,
            sortColumnOption: this.sortColumnOption,
          };

          const url = this.SERVER + "/VNSPRAAPI/Reports/VisitTypeReasonStage";
          this.axiosGetData(url, 2, myData);
        },
      fetchInitData() {
        this.intDummyComm();  
        
       //debugger
        //visitType&R&stages
        if (this.selectedVisitT.length > 0) {
          let aaT = [];
         for (let i = 0; i < this.selectedVisitT.length; i++)
          aaT.push(this.selectedVisitT[i].visitTypeId);
          this.visitTypeVa = aaT.toString();
        } if (this.selectedVisitR.length > 0) {
          let aaR = [];
         for (let i = 0; i < this.selectedVisitR.length; i++)
          aaR.push(this.selectedVisitR[i].visitDetailId);
          this.visitRVal = aaR.toString();
        } if (this.selectedStageT.length > 0) {
         let aaS = [];
        for (let i = 0; i < this.selectedStageT.length; i++)
          if(this.selectedStageT[i].stageId == 0){
            this.stageRVal_1 = this.selectedStageT[i].name;
          }
          else{
          aaS.push(this.selectedStageT[i].stageId);
          this.stageRVal = aaS.toString();
          }
        }

            if (this.selectedUsers.length > 0) {
                let aa = [];
                for (let i = 0; i < this.selectedUsers.length; i++)
                    aa.push(this.users[this.selectedUsers[i]].id);
                this.dummyComm.extras = aa.toString();
            } else this.dummyComm.extras = "";

            if (this.selectedPractice + "".length > 0) {
                this.dummyComm.extras1 = this.selectedPractice;
            } else this.dummyComm.extras1 = "";

            if (this.initDatePR.length > 0) {
                this.dummyComm.myDate = this.dateToSqlServerDateFormat(
                    this.startDatePR
                );
                this.dummyComm.myTime = this.dateToSqlServerDateFormat(this.endDatePR);
            } else {
                this.dummyComm.myDate = null;
                this.dummyComm.myTime = null;
            }
     
            this.dummyComm.pageNumber = this.pageNumber;
            this.dummyComm.pageSize = this.pageSize;
            this.dummyComm.filter = "";
            
            const filter = {
                veinsId: this.filter.veinsId,
                externalId: this.filter.externalId,
                firstName: this.filter.firstName,
                category: this.visitTypeVa,
                reason: this.visitRVal,
                stage: this.stageRVal,
                step: this.stageRVal_1,
                lastName: this.filter.lastName,
                phone: "",
                startDate: "",
                endDate: "",
              };
        
            const myData = {
              dc: this.dummyComm,
              filter: filter,
              sortColumn: this.sortColumn,
              sortColumnOption: this.sortColumnOption,
            };

            const url = this.SERVER + "/VNSPRAAPI/Reports/DailyReportInitData";
            this.axiosGetData(url, 1, myData);
        },

        //------------------------------------------ Common Methods
        async axiosGetData(myUrl, what, myData) {
            var loader = this.$loading.show({
                // Optional parameters
                  color: '#03a9f3'
                });
            await axios({
                method: "post",
                url: myUrl,
                data: myData,
                 headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
            })
                .then((res) => {
                    loader.hide();
                    // if everything goes well -- we will get data
                    this.lastErrorCode = 1;
                    if (what === 1) {
                        this.totalRows = res.data.dc.totalRow;
                        this.totalPages = res.data.dc.totalPages;
                        this.users = res.data.users;
                        this.practices = res.data.practices;
                        this.inData = res.data.outData;
                        this.visitRVal = "";
                        this.visitTypeVa = "";
                        this.stageRVal = "";
                        this.stageRVal_1 = "";
                    }
                    if (what === 2) {
                      this.visitType = res.data.visitType;
                      this.visitReason_1 = res.data.visitDetail;
                      this.stageName = res.data.stageDetail;
                  }
                })
                .catch(function (error) {
                    if (error.response) {
                        this.lastErrorCode = 1;
                        alert("-> " + error.response.data);
                        alert("-> " + error.response.status);
                        alert("-> " + error.response.headers);
                    } else if (error.request) {
                        this.lastErrorCode = 1;
                        alert("No response " + error.request);
                    } else {
                        this.lastErrorCode = 1;
                        alert("Error", error.message);
                    }
                })
                .finally(() => {
                    this.ResetLogoutTime();
                    loader.hide();
                 });
        }, // axiosGetData

    }, // end methods

    watch: {
        initDatePR: function () {
            this.pageNumber = 1;
            this.fetchInitData();
        },
        selectedUsers: function () {
            this.fetchInitData();
        },

        selectedPractice: function () {
            this.fetchInitData();
        },

        users: function (val) {
            this.usersList = [];
            for (let i = 0; i < val.length; i++) {
                this.usersList.push(val[i].name);
            }
        },

        practices: function() {
            this.practices.unshift({value:-99,label:""});
        },

        inData: function () {
            let obj = this.inData;
            for (let i = 0; i < obj.length; i++) {
                let dd = new Date(obj[i].dos);
                obj[i].dosStr = dd.toLocaleDateString();

                dd=new Date(obj[i].stageTime);
                obj[i].stageTimeStr = this.dateToLocalString(dd);
            }
        },

    }, // watch
    mounted(){
      if(this.$store.getters.getAuthToken==="")
    {
        this.$store.commit('setAuthToken',localStorage.BeToken);
    }
    },
    unmounted() {
        clearTimeout(this.TimerObject);
      },
}